module.exports = __webpack_public_path__ + "img/filter.a0dafb5a.svg";